<template>
  <div v-if="allowableElements.includes(element.type)">
    <text-element
      :scale-factor="scaleFactor"
      :element="element"
      v-if="element.type == 'TEXT'"
    ></text-element>

    <title-element
      :scale-factor="scaleFactor"
      :element="element"
      v-if="element.type == 'TITLE'"
    ></title-element>

    <image-element
      :element="element"
      :scale-factor="scaleFactor"
      v-if="element.type == 'IMAGE'"
    ></image-element>

    <video-element
      :element="element"
      :scale-factor="scaleFactor"
      v-if="element.type == 'VIDEO'"
    ></video-element>

    <space-element
      :scale-factor="scaleFactor"
      :element="element"
      v-if="element.type == 'SPACE'"
    >
    </space-element>
     <audio-element
      :scale-factor="scaleFactor"
      :element="element"
      v-if="element.type == 'AUDIO'"
    >
    </audio-element>
  </div>
</template>

<script>
// import Component from "../component_location"
import TextElement from "@/components/NarrativeElements/TextElement.vue";
import TickElement from "@/components/NarrativeElements/TickElement.vue";
import TitleElement from "@/components/NarrativeElements/TitleElement.vue";
import ImageElement from "@/components/NarrativeElements/ImageElement.vue";
import SpaceElement from "@/components/NarrativeElements/SpaceElement.vue";
import VideoElement from "@/components/NarrativeElements/VideoElement.vue";
import AudioElement from "@/components/NarrativeElements/AudioElement.vue";


export default {
  components: {
    TextElement,
    TickElement,
    TitleElement,
    ImageElement,
    SpaceElement,
    VideoElement,
    AudioElement
  },

  props: {
    element: { type: Object, default: () => {} },
    scaleFactor: { type: Number, default: 1.0 },
  },

  data() {
    return {
      allowableElements: ["TEXT", "VIDEO", "IMAGE", "SPACE", "AUDIO", "TITLE"],
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {
  },
};
</script>

<style></style>